export const MENU_ESTIMATED_WIDTH = 176;
const VIEWPORT_PAD = 8;

/** Garde un menu fixe entièrement visible horizontalement (LTR / RTL). */
export function clampMenuLeft(
  trigger: DOMRect,
  menuWidth: number,
  align: 'start' | 'end',
): number {
  let left = align === 'end' ? trigger.right - menuWidth : trigger.left;
  left = Math.max(VIEWPORT_PAD, left);
  left = Math.min(left, window.innerWidth - menuWidth - VIEWPORT_PAD);
  return left;
}
